module.exports = __webpack_public_path__ + "img/explore-zubut-banner-short.5c0f7027.png";